
import { Component, Vue } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';

@Component({
  components: { VWrapper },
})
export default class LightspeedSuccess extends Vue {}
